import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { enableSearchSelector, apiEnvSelector } from 'common/selectors/appSelector';
import pageSelector from 'common/selectors/pageSelector';
import SearchResultAsList from 'common/search/SearchResultAsList';
import { PageType, BucketLayout, Api, SortOrder } from 'enums';
import { FormattedMessage } from 'react-intl';
import Bucket from 'common/page/buckets/Bucket';
import injectIntl from 'common/injectIntl';
import DownloadLink from 'common/DownloadLink';
import { getSearchResults, SEARCH_TYPES } from 'common/actions/apiAction';

const overflowStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};

class SearchResultsContainer extends Component {
    constructor(props) {
        super(props);
        this.appendScore = this.appendScore.bind(this);
        this.fillBuckets = this.fillBuckets.bind(this);
        this.changeSortOrder = this.changeSortOrder.bind(this);
        this.state = { buckets: [] };
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.scored && !this.props.scored) || (nextProps.searchTerm !== this.props.searchTerm)) {
            let searchType = SEARCH_TYPES.search;
            if (PageType.SID === nextProps.pageType) {
                searchType = SEARCH_TYPES.listingsByCompetitor;
            }
            this.fillBuckets(nextProps.searchTerm, searchType);
        }
    }

    getContainerHeader() {
        const { messages, searchTerm, pageType } = this.props;
        let downloadLink;

        if (pageType === PageType.SID && searchTerm.length > 0) {
            const fileName = `${this.state.pageName}-Schedule.csv`;
            downloadLink = (
                <DownloadLink
                    buckets={this.state.buckets}
                    text="Download Schedule"
                    fileName={fileName}
                    mimeType="text/csv"
                />);
        }

        return (
            <div className="search-results-header" style={{ textAlign: 'center', padding: '16px' }}>
                <h1>
                    <FormattedMessage
                        {...messages['search.results.message']}
                        values={{
                            query: <strong style={overflowStyle}>{searchTerm}</strong>
                        }}
                    />
                </h1>
                {downloadLink}
                <hr width="98%" />
            </div>
        );
    }

    appendScore(contents) {
        if (this.props.apiEnv !== Api.Env.DEV) {
            return contents;
        }
        return contents.map((content) => {
            if (content.name) {
                if (!content.name.match(/\(\d*\)/g)) {
                    content.name = `(${content.score}) - ${content.name}`;
                }
            }
            return content;
        });
    }

    fillBuckets(query, queryType = SEARCH_TYPES.search, sortBy = 'startTime', sortOrder = SortOrder.DESC) {
        const { dispatch, apiEnv } = this.props;
        dispatch(getSearchResults(query, apiEnv, queryType, sortBy, sortOrder))
            .then(({ page: { buckets = [], name: pageName } }) => (this.setState({ buckets, pageName })))
            .catch((err) => console.warn(err));
    }

    changeSortOrder(sortBy, sortOrder) {
        const { searchTerm } = this.props;
        this.fillBuckets(searchTerm, SEARCH_TYPES.listingsByCompetitor, sortBy, sortOrder);
    }

    render() {
        if (!this.props.enableSearch) {
            return null;
        }
        const { pageType } = this.props;
        const containerHeader = this.getContainerHeader();

        let bucketResults;
        const buckets = this.state.buckets || [];
        if (buckets.length > 0 && pageType !== PageType.SID) {
            bucketResults = buckets.map((bucket, index) => {
                const { id, name, metadata, contents = [], tags = [] } = bucket;
                const tag = name === 'Videos' ? BucketLayout.LARGE_EXPANDABLE : BucketLayout.DEFAULT_EXPANDABLE;
                return (
                    <Bucket
                        contents={(this.appendScore(contents))}
                        index={index}
                        key={`${id}-${name}`}
                        layoutType={BucketLayout.DEFAULT_UNLIMITED}
                        metadata={metadata}
                        name={name}
                        pageType={pageType}
                        tags={[tag, ...tags]}
                    />);
            });
        } else if (pageType === PageType.SID) {
            bucketResults = buckets.map((bucket) => {
                const { contents = [] } = bucket;
                return (<SearchResultAsList
                    contents={contents}
                    sortContents={this.changeSortOrder}
                />);
            });
        }
        return (
            <div className="search-result-container" style={{ backgroundColor: 'white' }}>
                {containerHeader}
                {bucketResults}
            </div>
        );
    }
}

SearchResultsContainer.propTypes = {
    dispatch: PropTypes.func.isRequired,
    searchTerm: PropTypes.string,
    messages: PropTypes.object.isRequired,
    enableSearch: PropTypes.bool,
    apiEnv: PropTypes.string,
    scored: PropTypes.bool,
    pageType: PropTypes.string
};

const mapStateToProps = (state) => ({
    apiEnv: apiEnvSelector(state),
    enableSearch: enableSearchSelector(state),
    scored: pageSelector(state).scored
});

export default injectIntl(connect(mapStateToProps)(SearchResultsContainer));



// WEBPACK FOOTER //
// ./app/common/page/search/SearchResultsContainer.js